import { render, staticRenderFns } from "./SPA.vue?vue&type=template&id=3cdc19c4&scoped=true"
import script from "./SPA.vue?vue&type=script&lang=js"
export * from "./SPA.vue?vue&type=script&lang=js"
import style0 from "./SPA.vue?vue&type=style&index=0&id=3cdc19c4&prod&scoped=true&lang=css"
import style1 from "./SPA.vue?vue&type=style&index=1&id=3cdc19c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc19c4",
  null
  
)

export default component.exports